export interface Factory<T, C> {
  add: (t: T, c: C) => void;
  create: (t: T, a?: any) => C;
}

// TODO: replace this factory with new plans domain factory
export const createFactory = <T, C>(): Factory<T, C> => {
  const fields: Map<T, C> = new Map();

  return {
    create(type) {
      if (!fields.has(type)) {
        throw new Error(`Create factory: ${String(type)} is not found!`);
      }

      return fields.get(type)!;
    },

    add(type: T, component: C) {
      console.warn('Use BaseFactory class instead.');
      fields.set(type, component);
    },
  };
};
